import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowLeft, Shield } from "lucide-react";
import adminApi from "@/lib/adminApi";
import { toast } from "sonner";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await adminApi.post("/admin/login", form);
      localStorage.setItem("kobolog_admin_token", r.data.token);
      toast.success("Welcome back, admin");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[100dvh] bg-kudi-ink text-white relative overflow-hidden">
      <div className="absolute inset-0 noise-overlay opacity-50" aria-hidden />
      <header className="px-5 py-4 relative">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white" data-testid="admin-back-link">
          <ArrowLeft className="w-4 h-4" /> Back to app
        </Link>
      </header>
      <div className="flex-1 flex items-center justify-center px-5 pb-10 pt-12 relative">
        <div className="w-full max-w-sm">
          <div className="text-center mb-8">
            <div className="w-14 h-14 mx-auto rounded-2xl bg-kudi-terracotta flex items-center justify-center text-white mb-4">
              <Shield className="w-7 h-7" />
            </div>
            <h1 className="font-heading text-3xl font-bold">Admin Console</h1>
            <p className="mt-2 text-white/60 text-sm">Kobolog AI · Operations</p>
          </div>
          <form onSubmit={submit} className="space-y-3">
            <input
              type="email" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="admin@kobolog.ai" autoFocus
              className="w-full bg-white/10 backdrop-blur border border-white/15 rounded-xl px-4 py-3.5 text-base focus:outline-none focus:border-kudi-terracotta focus:bg-white/15 transition placeholder:text-white/40"
              data-testid="admin-email"
            />
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
              <input
                type="password" value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                placeholder="Password"
                className="w-full bg-white/10 backdrop-blur border border-white/15 rounded-xl pl-11 pr-4 py-3.5 text-base focus:outline-none focus:border-kudi-terracotta focus:bg-white/15 transition placeholder:text-white/40"
                data-testid="admin-password"
              />
            </div>
            <button type="submit" disabled={loading} className="w-full bg-kudi-terracotta text-white rounded-full py-3.5 font-semibold hover:bg-kudi-terracotta/90 transition disabled:opacity-50" data-testid="admin-login-btn">
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
